/**
 * Design tokens — fonte única de verdade visual do produto.
 *
 * Estes valores são intencionalmente JS puro (sem dependência de MUI) para que
 * a Fase 2 da migração possa emiti-los como CSS custom properties consumidas
 * pelo Tailwind/shadcn sem reescrever nada. Não hardcode cor em componente:
 * importe daqui ou use o `theme.palette` derivado.
 */

// Escala neutra (slate) — base de superfícies, bordas e texto.
export const neutral = {
  0: "#FFFFFF",
  50: "#F8FAFC",
  100: "#F1F5F9",
  200: "#E2E8F0",
  300: "#CBD5E1",
  400: "#94A3B8",
  500: "#64748B",
  600: "#475569",
  700: "#334155",
  800: "#1E293B",
  900: "#0F172A",
  950: "#080F1D",
};

// Marca — o navy da sidebar e o dourado de seleção já eram a identidade do
// InManager; foram preservados e promovidos a token.
export const brand = {
  navy: "#2F3F64",
  navyDeep: "#26334F",
  gold: "#EAC95C",
  goldDim: "rgba(234,201,92,0.18)",
};

// Ação primária. Blue-700 no claro (7.0:1 com texto branco) e blue-500 no
// escuro, onde o fundo é que precisa de contraste.
export const accent = {
  main: "#1D4ED8",
  hover: "#1E40AF",
  light: "#3B82F6",
  soft: "#EFF6FF",
  onDark: "#60A5FA",
};

// Cores semânticas de estado. Tons 700 — leem como software corporativo, não
// como dashboard de consumo.
export const semantic = {
  success: { main: "#15803D", soft: "#F0FDF4", onDark: "#4ADE80" },
  warning: { main: "#B45309", soft: "#FFFBEB", onDark: "#FBBF24" },
  danger: { main: "#B91C1C", soft: "#FEF2F2", onDark: "#F87171" },
  info: { main: "#0E7490", soft: "#ECFEFF", onDark: "#22D3EE" },
  neutral: { main: neutral[600], soft: neutral[100], onDark: neutral[400] },
};

export const radius = {
  sm: 6,
  md: 8,
  lg: 12,
  xl: 16,
  pill: 999,
};

export const spacingUnit = 8;

export const fontFamily = [
  "Inter",
  "-apple-system",
  "BlinkMacSystemFont",
  "Segoe UI",
  "Roboto",
  "Helvetica Neue",
  "Arial",
  "sans-serif",
].join(", ");

export const fontFamilyMono = [
  "ui-monospace",
  "SFMono-Regular",
  "Menlo",
  "Consolas",
  "monospace",
].join(", ");

// Alturas fixas do chrome. Usadas pelo layout e pelo PageHeader para que o
// scroll interno das páginas feche a conta certo.
export const layout = {
  appBarHeight: 60,
  drawerWidth: 240,
};
